import clsx from 'clsx'
import { FC, useContext, useEffect, useState } from 'react'
import { toAbsoluteUrl } from '../../../helpers'
import { useLang, setLanguage, I18nContext } from '../../../i18n/Metronici18n'
import { useIntl } from 'react-intl'
import { LanguagesIcon } from 'lucide-react'
interface languagesType {
  lang: 'en' | 'fa'
  name: string
  flag: string
  dir: 'ltr' | 'rtl'
}
const languages: languagesType[] = [
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('media/flags/united-states.svg'),
    dir: 'ltr',
  },
  {
    lang: 'fa',
    name: 'Persian',
    flag: toAbsoluteUrl('media/flags/iran.svg'),
    dir: 'rtl',
  },
]
type Props = {
  toggleBtnClass?: string
  toggleBtnIconClass?: string
  menuPlacement?: string
  menuTrigger?: string
  manual?: boolean
  color?: string
}
const Languages: FC<Props> = ({
  color = "",
  toggleBtnClass = '',
  toggleBtnIconClass = 'fs-1',
  menuPlacement = 'bottom-end',
  menuTrigger = "{default: 'hover', lg: 'hover'}",
  manual = false,
}: Props) => {
  const lang = useLang()?.lang.selectedLang
  const intl = useIntl()
  const currentLanguage = languages.find((x) => lang && x.lang === lang)
  const setLang = useContext(I18nContext)?.setLang

  return (
    <>
      <div
        className={toggleBtnClass}
        data-kt-menu-trigger={menuTrigger}
        data-kt-menu-attach='parent'
        data-kt-menu-placement={menuPlacement}
      >
        {color ? <LanguagesIcon size={20} strokeWidth={1.75} color={color} /> : <LanguagesIcon size={20} strokeWidth={1.75} />}
      </div>

      <div
        className={`${manual && 'show'
          }  menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px`}
        data-kt-menu='true'
      >
        {languages?.map((l) => (
          <div
            className='px-3 menu-item'
            key={l.lang}
            onClick={() => {
              setLanguage(l.lang, l.dir)
              if (setLang) setLang({ selectedLang: l.lang, dir: l.dir })
            }}
          >
            <a
              href='#'
              className={clsx('d-flex px-5 menu-link', {
                active: l.lang === currentLanguage?.lang,
              })}
            >
              <span className='symbol symbol-20px me-4'>
                <img className='rounded-1' src={l.flag} alt='metronic' />
              </span>
              {l.name}
            </a>
          </div>
        ))}
      </div>
    </>
  )
}

export { Languages }
